import { Box } from "@mui/material";
import Placeholder from "@Resources/game/backgrounds/3.jpg";
import { HeroOverlay } from "./styled-components";

const HeroBackground = () => {
  return (
    <Box sx={{ position: "absolute", top: 0, height: "520px", width: "100vw", pointerEvents: "none", zIndex: -1 }}>
      <img src={Placeholder} style={{ height: "100%", width: "100%", objectFit: "cover" }} />
      <HeroOverlay />
    </Box>
  );
};

export default HeroBackground;
